import { countries } from './countries';
import { provinces } from './provinces';

function uploadPathGroup(options) {
  return [];
}


export function basicPolicyFields(referrerLabel) {
  return [
    {
      key_path: ['applicant', '0', 'policy_number'],
      as: 'Policy Number',
      is_static_by_default: true
    },
    {
      key_path: ['application', 'sale_date'],
      as: 'Sale Date',
      format: 'date',
      is_static_by_default: true
    },
    {
      key_path: ['application', 'status'],
      as: 'Status',
      type: 'custom:status',
      args: {
        key_paths: {
          is_active: ['application', 'active'],
          effective_date: ['application', 'effective_date'],
          expiry_date: ['application', 'expiry_date'],
          status: ['application', 'status']
        }
      }
    },
    {
      as: 'Language',
      type: 'custom:language',
      key_path: ['application', 'locale'],
      args: {
        key_paths: {
          locale: ['application', 'locale']
        }
      },
      admin_and_superadmin_edit_only: true
    },
    {
      key_path: ['application', 'additional_data', 'sales_channel'],
      as: 'Sales Channel',
      type: 'typeahead'
    },
    {
      key_path: ['application', 'additional_data', 'affiliate_code'],
      as: 'Affiliate',
      type: 'asynctypeahead',
      do_not_show_if: [{
        key_path: ['application', 'additional_data', 'affiliate_code'],
        values: ['RIMI', 'MSG', '2 Visit Canada Inc.', 'insurecanada']
      }],
    },
    {
      key_path: ['application', 'additional_data', 'tracking_code'],
      as: referrerLabel,
      admin_edit_only: true
    },
  ];
}

export function basicCoverageFields(dateLimits = null) {
  return [
    // {
    //   key_path: ['application', 'additional_data', 'additional_applicants_number'],
    //   as: 'Number of Additional Applicants'
    // },
    {
      key_path: ['application', 'effective_date'],
      as: 'Effective Date',
      format: 'date',
      max_date: dateLimits ? dateLimits.effective_date.max : null,
      min_date: dateLimits ? dateLimits.effective_date.min : null
    },
    {
      key_path: ['application', 'expiry_date'],
      as: 'Expiry Date',
      format: 'date',
      show_if: [{
        key_path: ['application', 'additional_data', 'extension_end'],
        value: undefined
      }]
    },
    {
      key_path: ['application', 'additional_data', 'extension_end'],
      as: 'Expiry Date',
      is_static_by_default: true,
      do_not_show_if: [{
        key_path: ['application', 'additional_data', 'extension_end'],
        value: undefined
      }]
    },
    {
      key_path: ['application', 'additional_data', 'coverage_length'],
      as: 'Coverage Length',
      is_static_by_default: true
    },
    {
      key_path: ['application', 'additional_data', 'umr'],
      as: 'UMR',
      is_static_by_default: true,
      do_not_show_if: [{
        key_path: ['application', 'additional_data', 'umr'],
        value: undefined
      },
      {
        key_path: ['application', 'additional_data', 'umr'],
        value: null
      }],
    }
  ]
}

export function provinceOfResidenceFields() {
  return [
    {
      key_path: ['application', 'additional_data', 'province_of_residence'],
      as: 'Province of Residence',
      type: 'dropdown',
      options: provinces('CA'),
      show_if: [{
        key_path: ['application', 'additional_data', 'country_of_origin'],
        value: 'CA'
      }],
    },
    {
      key_path: ['application', 'additional_data', 'province_of_residence'],
      as: 'State of Residence',
      type: 'dropdown',
      options: provinces('US'),
      show_if: [{
        key_path: ['application', 'additional_data', 'country_of_origin'],
        value: 'US'
      }],
    },
    {
      key_path: ['application', 'additional_data', 'province_of_residence'],
      as: 'Province/State of Residence',
      do_not_show_if: [{
        key_path: ['application', 'additional_data', 'country_of_origin'],
        value: 'CA'
      },
      {
        key_path: ['application', 'additional_data', 'country_of_origin'],
        value: 'US'
      }],
    }
  ]
}

export function basicContactFields() {
  return [
    {
      key_path: ['applicant', '0', 'email'],
      as: 'Email Address'
    },
    {
      key_path: ['applicant', '0', 'additional_data', 'cc_email'],
      as: 'Additional Email Address'
    },
    {
      key_path: ['applicant', '0', 'phone'],
      as: 'Phone Number'
    },
    {
      key_path: ['applicant', '0', 'address_line_1'],
      as: 'Address Line 1'
    },
    {
      key_path: ['applicant', '0', 'address_line_2'],
      as: 'Address Line 2'
    },
    {
      key_path: ['applicant', '0', 'city'],
      as: 'City'
    },
    {
      key_path: ['applicant', '0', 'state'],
      as: 'Province',
      type: 'dropdown',
      options: provinces('CA'),
      do_not_show_if: [{
        key_path: ['applicant', '0', 'state'],
        value: undefined
      }],
      show_if: [{
        key_path: ['applicant', '0', 'country_code'],
        value: 'CA'
      }],
    },
    {
      key_path: ['applicant', '0', 'state'],
      as: 'State',
      type: 'dropdown',
      options: provinces('US'),
      do_not_show_if: [{
        key_path: ['applicant', '0', 'state'],
        value: undefined
      }],
      show_if: [{
        key_path: ['applicant', '0', 'country_code'],
        value: 'US'
      }],
    },
    {
      key_path: ['applicant', '0', 'state'],
      as: 'State/Province',
      do_not_show_if: [{
        key_path: ['applicant', '0', 'country_code'],
        value: 'CA'
      }, {
        key_path: ['applicant', '0', 'country_code'],
        value: 'US'
      }],
    },
    {
      key_path: ['applicant', '0', 'country_code'],
      as: 'Country',
      type: 'dropdown',
      options: countries()
    },
    {
      key_path: ['applicant', '0', 'postal_code'],
      as: 'Postal Code',
      show_if: [{
        key_path: ['applicant', '0', 'country_code'],
        value: 'CA'
      }],
    },
    {
      key_path: ['applicant', '0', 'postal_code'],
      as: 'Zip Code',
      show_if: [{
        key_path: ['applicant', '0', 'country_code'],
        value: 'US'
      }],
    },
    {
      key_path: ['applicant', '0', 'postal_code'],
      as: 'Postal/Zip Code',
      do_not_show_if: [{
        key_path: ['applicant', '0', 'country_code'],
        value: 'CA'
      }, {
        key_path: ['applicant', '0', 'country_code'],
        value: 'US'
      }],
    },
  ]
}

export function primaryApplicantStudentFields() {
  return [
    {
      key_path: ['application', 'additional_data', 'school'],
      as: 'Name of School'
    },
    ...studentNumberFields('0'),
    {
      key_path: ['application', 'associated_policy'],
      as: 'Associated Student Policy',
      do_not_show_if: [{
        key_path: ['application', 'associated_policy'],
        value: null
      }],
      is_static_by_default: false
    },
    {
      key_path: ['applicant', '0', 'additional_data', 'relationship_to_student'],
      as: 'Relationship to Student',
      do_not_show_if: [{
        key_path: ['application', 'associated_policy'],
        value: null
      }],
      is_static_by_default: false,
      type: 'dropdown',
      options: [
        { value: 'parent', text: 'Parent/Guardian' },
        { value: 'dependent', text: 'Dependent Child' },
        { value: 'spouse', text: 'Spouse' },
        { value: 'teacher', text: 'Teacher' },
        { value: 'chaperone', text: 'Chaperone' }
      ]
    }
  ];
}

export function legalGuardianFields(splitName = false) {

  if (splitName) {
    return [
      {
        key_path: ['applicant', '0', 'additional_data', 'legal_guardian_fname'],
        as: 'Legal Guardian First Name'
      },
      {
        key_path: ['applicant', '0', 'additional_data', 'legal_guardian_lname'],
        as: 'Legal Guardian Last Name'
      },
    ];
  }

  return [
    {
      key_path: ['applicant', '0', 'additional_data', 'legal_guardian'],
      as: 'Legal Guardian'
    }
  ];
}

export function applicantFields(position, relationshipOptions = []) {
  let fields = [
    {
      key_path: ['applicant', position, 'policy_number'],
      as: 'Policy Number',
      is_static_by_default: true
    },
    {
      key_path: ['applicant', position, 'first_name'],
      as: 'First Name'
    },
    {
      key_path: ['applicant', position, 'last_name'],
      as: 'Last Name'
    },
    {
      key_path: ['applicant', position, 'dob'],
      key_path_aliases: [['applicant', position, 'years'], ['applicant', position, 'days']],
      as: 'Date of Birth',
      format: 'date',
      affects_premium: true,
      override_affects_premium: [['schooladmin', 'active', 'lloydscomprehensiveplus']],
    },
    {
      key_path: ['applicant', position, 'ages', 'years'],
      as: 'Age on effective date',
      is_static_by_default: true
    },
    {
      key_path: ['applicant', position, 'sex'],
      as: 'Gender',
      type: 'radio',
      options: [
        { value: 'female', text: 'Female' },
        { value: 'male', text: 'Male' },
        { value: 'non-binary', text: 'Non-Binary' },
        { value: 'undeclared', text: 'Undeclared' }
      ]
    },
    {
      key_path: ['applicant', position, 'magenta_link'],
      as: 'Magenta Policy',
      format: 'link',
      only_msh_admin: true
    }
  ];

  if (relationshipOptions.length > 0) {
    fields.push({
      key_path: ['applicant', '*', 'additional_data', 'relationship_to_primary_applicant'],
      as: 'Relationship to Primary Applicant',
      type: 'dropdown',
      options: relationshipOptions,
      is_static_by_default: true
    })
  }

  return fields;
}

export function premiumField(position) {
  return [
    {
      key_path: ['applicant', position, 'premium'],
      as: 'Premium',
      format: 'currency',
      editable_if_override: true,
      show_if: [{
        key_path: ['application', 'additional_data', 'affiliate_code'],
        values: ['RIMI', '2 Visit Canada Inc.', 'insurecanada']
      }]
    }
  ];
}

export function schoolFields(position) {
  return [
    {
      key_path: ['application', 'additional_data', 'school_name'],
      as: 'School'
    },
    {
      key_path: ['applicant', '0', 'additional_data', 'student_id'],
      as: 'Student ID'
    }
  ];
}

export function studentNumberFields(position) {
  return [
    {
      key_path: ['applicant', position, 'additional_data', 'student_number'],
      as: 'Student Number'
    },
    {
      key_path: ['applicant', position, 'additional_data', 'student_number_extension'],
      as: 'Student ID Number Extension',
      do_not_show_if: [{
        key_path: ['applicant', position, 'additional_data', 'student_number_extension'],
        value: undefined
      }, {
        key_path: ['applicant', position, 'additional_data', 'student_number_extension'],
        value: ''
      }],
    }
  ];
}

export function basicBeneficiaryFields() {
  return [
    {
      key_path: ['applicant', '0', 'additional_data', 'beneficiary', 'name'],
      as: 'Name'
    },
    {
      key_path: ['applicant', '0', 'additional_data', 'beneficiary', 'relationship_to_insured'],
      as: 'Relationship to Insured'
    }
  ];
}

export function detailedBeneficiaryFields() {
  return [
    {
      key_path: ['applicant', '0', 'additional_data', 'beneficiary', 'address'],
      as: 'Address'
    },
    {
      key_path: ['applicant', '0', 'additional_data', 'beneficiary', 'city'],
      as: 'City'
    },
    {
      key_path: ['applicant', '0', 'additional_data', 'beneficiary', 'country_code'],
      as: 'Country',
      type: 'dropdown',
      options: countries()
    },
  ];
}

export function emailNotificationFields() {
  return [
    {
      as: 'Sent Confirmation',
      key_path: ['email', 'insurance']
    },
    {
      as: 'Sent Renewal',
      key_path: ['email', 'renewal']
    },
    {
      as: 'Sent Cancellation',
      key_path: ['email', 'cancellation']
    },
    {
      as: 'Automatic Confirmation',
      key_path: ['email', 'auto_confirmation']
    },
    {
      as: 'Automatic Payment Failure',
      key_path: ['email', 'auto_failure']
    },
    {
      as: 'Automatic Cancellation',
      key_path: ['email', 'auto_cancellation']
    },
    {
      as: 'Automatic Termination',
      key_path: ['email', 'auto_termination']
    },
    {
      as: 'Automatic Renewal',
      key_path: ['email', 'auto_renewal']
    },
    {
      as: 'Automatic Reminder',
      key_path: ['email', 'auto_reminder']
    },
    {
      as: 'Automatic Dispute',
      key_path: ['email', 'auto_dispute']
    }
  ];
}

export function magentaAccessFields() {
  return [
    {
      as: 'Connection Attempt',
      key_path: ['connection', 'attempt']
    }
  ];
}

export function feeRefundFields() {
  return [
    {
      as: 'Policy Issue Fee',
      key_path: ['payment', 'policy_issue_fee']
    },
    {
      as: 'Cancellation Fee',
      key_path: ['payment', 'cancellation_fee']
    },
    {
      as: 'Transaction Fee',
      key_path: ['payment', 'transaction_fee']
    },
  ];
}

export function peCoverageField(position, org) {
  return [
    {
      key_path: ['applicant', position, 'additional_data', 'pe_coverage'],
      as: 'Include coverage for stable pre-existing medical conditions',
      type: 'dropdown',
      options: ['ingle', 'msg'].includes(org) ? [
        { value: 'yes', text: 'Yes' },
        { value: 'no', text: 'No' }
      ] :
        [
          { value: 'yes', text: 'Yes (Plan 2)' },
          { value: 'no', text: 'No (Plan 1)' }
        ],
      affects_premium: true,
      restricted_field_edit_to: [[org, 'agent', 'active']],
      do_not_show_if: [{
        key_path: ['applicant', position, 'additional_data', 'pe_coverage'],
        value: undefined
      }],
    },
    {
      key_path: ['applicant', position, 'additional_data', 'coverage'],
      as: 'Coverage',
      type: 'dropdown',
      options: [
        {value: 50000, text: '$50,000.00 CAD'},
        {value: 100000, text: '$100,000.00 CAD'},
        {value: 150000, text: '$150,000.00 CAD'},
        {value: 250000, text: '$250,000.00 CAD'},
        {value: 500000, text: '$500,000.00 CAD'},
        {value: 1000000, text: '$1,000,000.00 CAD'}
      ],
      do_not_show_if: [{
        key_path: ['applicant', position, 'additional_data', 'coverage'],
        value: undefined
      }],
    }
  ];
}

export function splitPolicyButton() {
  return [
    {
      key_path: ['applicant', '*', 'policy_number'],
      as: 'Set as Primary',
      type: 'button',
      action: 'set_primary',
      icon: 'refresh',
      show_only_when: 'view',
      is_static_by_default: true,
      only_pmo_admin: true,
    },
    {
      key_path: ['applicant', '*', 'policy_number'],
      as: 'Split Policy',
      type: 'button',
      action: 'split_policy',
      icon: 'unlock',
      show_only_when: 'view',
      is_static_by_default: true,
      only_pmo_admin: true,
    }
  ];
}

export function overridePremiumFields() {
  return [
    {
      key_path: ['application', 'override_premium'],
      as: 'Override Premium',
      type: 'button',
      action:'override_premium',
      show_only_when: 'view',
      is_static_by_default: true,
      only_msh_admin: true,
      show_if: [
        {
          function: 'invoice'
        }
      ]
    }
  ];
}

export function sportsCoverageFields(position) {
  return [
    {
      key_path: ['applicant', position, 'additional_data', 'sports'],
      as: 'Sports',
      //type: 'checkboxgroup',
      format: 'multivalue',
    }
  ];
}



// WEBPACK FOOTER //
// ./src/helpers/fields.js